import { Validator } from '@leverege/validator';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('openApi.attributeValidator.RequiredValidator');
export default {
  type: 'required',
  validator: (model, attr) => ({
    active: true,
    validate: value => {
      const valid = Validator.required(value);
      if (!valid) {
        return t('invalid', {
          attrName: attr.displayName
        });
      }
      return true;
    }
  })
};